import { FC, ReactNode } from 'react';
import { InputNumberProps } from '../InputNumber';
import { Container, InputNumber } from './styled';

interface InputNumberAddonProps extends InputNumberProps {
  addonBefore?: ReactNode;
  addonAfter?: ReactNode;
}

const InputNumberAddon: FC<InputNumberAddonProps> = ({
  addonBefore,
  addonAfter,
  ...props
}) => (
  <Container className="ant-input">
    {addonBefore && <span style={{ marginRight: 4 }}>{addonBefore}</span>}
    <InputNumber {...props} />
    {addonAfter && <span style={{ marginLeft: 4 }}>{addonAfter}</span>}
  </Container>
);

export default InputNumberAddon;
